enum UserType {
  Contact = 'Contact',
  Full = 'Full',
  Onboarding = 'Onboarding'
}
export default UserType
